<div data-testid="loading-spinner" *ngIf="showLoadingSpinner">
  <loading-indicator></loading-indicator>
</div>
<div data-testid="initialisation-error" class="alert alert-danger ms-2"
     *ngIf="showError">{{ localizationKey("uploadGetContextFailed") | localize }}
</div>
<div data-testid="upload-form" *ngIf="showForm" class="container">
  <div data-testid="deprecation-warning" *ngIf="feature621Released() && measurementId === undefined" class="alert alert-danger deprecation-warning">{{ localizationKey("uploadDeprecationWarning") | localize }}</div>
  <form class="form-striped">
    <form-field [config]="formConfig!.id"></form-field>
    <form-field [config]="formConfig!.type"></form-field>

    <form-field-wrapper *ngIf="shouldShowFileUpload()" [config]="formConfig!.file">
      <upload-measurement-file
        class="form-control-plaintext"
        [measurementId]="measurementId"
        [measurementType]="getMeasurementType(uploadFormModel.measurementType)!"
        [measurementCode]="uploadFormModel.measurementCode"
        [externalAnalysisType]="externalAnalysisType"
        (fileUploaded)="handlePropertyChange(formConfig!.file.property, $event.name)"
        (sessionId)="setUploadSessionId($event)">
      </upload-measurement-file>
    </form-field-wrapper>

    <hr/>

    <app-form-selector
      [type]="getMeasurementType(uploadFormModel.measurementType)!"
      [formConfig]="formConfig!"
      [ecgTechnicianAnalysisOnlyEnabled]="ecgTechnicianAnalysisOnlyEnabled"
    ></app-form-selector>

    <ng-container *ngIf="reportLanguageSelectionEnabled && isTypeSelected()">
      <hr/>
      <form-field [config]="formConfig!.reportLanguage"></form-field>
    </ng-container>

    <hr/>

    <div class="row" *ngIf="isTypeSelected()">
      <app-upload-button
        [uploadInProgress$]="uploadInProgress$"
        [codeCheckInProgress$]="codeCheckInProgress$"
        [measurementCodeExists]="measurementCodeExists"
        (uploadClick)="uploadClick()"
        [errorMessage]="errorMessage"
        [warningMessage]="warningMessage"
        [uploadButtonLabel]="getUploadButtonLabel()"
      ></app-upload-button>
    </div>
  </form>
</div>
